<template>
  <div>
    <div class="py-2" v-if="item.length === 0">
      <img :src="require('@/assets/images/empty.png')" height="200" width="100%"/>
    </div>
    <div class="pd-c-12" v-for="(res, idx) in item" :key="idx">
      <v-row>
        <v-col cols="12" :md='mini ? 3 : 4' :class="`size-13 ${idx === 0 ? 'pb-1' : 'py-1'}`">
          回款编号：<span class="grey--text text--darken-1">{{res.collectNumber}}</span>
        </v-col>
        <v-col :cols="$isMobile ? 6 : 12" :md='mini ? 3 : 4' class="size-13 py-1">
          回款类型：<span class="grey--text text--darken-1">{{res.returnTypeDic.name}}</span>
        </v-col>
        <v-col :cols="$isMobile ? 6 : 12" :md='mini ? 6 : 4' class="size-13 py-1">
          回款状态：<span class="grey--text text--darken-1">{{res.returnStateDic.name}}</span>
        </v-col>
      </v-row>

      <v-row>
        <v-col :cols="$isMobile ? 6 : 12" :md='mini ? 3 : 4' class="size-13 py-1">
          回款金额：<span class="grey--text text--darken-1">{{res.money}}</span>
        </v-col>
        <v-col :cols="$isMobile ? 6 : 12" :md='mini ? 3 : 4' class="size-13 py-1">
          回款日期：<span class="grey--text text--darken-1">{{res.returnTime | formatDay}}</span>
        </v-col>
        <v-col cols="12" :md='mini ? 6 : 4' class="size-13 py-1">
          备注信息：<span class="grey--text text--darken-1">{{res.descs}}</span>
        </v-col>
      </v-row>
      <v-divider class="mt-5" v-if="idx + 1 < item.length"></v-divider>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'CollectDetail',
    components: {
    },
    props: {
      item: {
        type: Array,
        default: () => ([])
      },
      mini: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
      }
    },
    methods: {
    }
  }
</script>

<style>
</style>
